import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRiskfactorMaster, selectOccupancy, selectAge,selectDescription,selectBoilerType,selectType,selectIndemnityPeriod,selectStipulatedAge, setDataSuccess, selectTestingPeriod, selectSTerritory, selectJurisdiction, selectBasisOfValuation, selectRiskCovered, selectConveyance, selectProjectType, selectModeOfTransit, selectPackingRf, selectProjectPeriod } from 'src/features/staticDataSlice';
import { checkPermission } from 'src/utils/permission';
import RiskFactorCreateModal from 'src/pages/PolicyProduct/RiskFactor/CommonRiskFactorForm/RiskFactorCreateModal';

const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function CommonRiskFactorList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  apiUrl,
  handleChange,
  riskFactorname = ''
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [riskFactorCreatePermission, setRiskFactorCreatePermission] = useState(false);

  const riskFactorData = useSelector(apiUrl.formKey=='age'?
        selectAge:apiUrl.formKey=='description'?selectDescription:apiUrl.formKey=='boilerType'?selectBoilerType:
        apiUrl.formKey=='type'?selectType:apiUrl.formKey=='stipulatedAge'?
        selectStipulatedAge:apiUrl.formKey=='indemnityPeriod'?selectIndemnityPeriod:apiUrl.formKey=='testingPeriod'?selectTestingPeriod:
        apiUrl.formKey=='territory'?selectSTerritory:apiUrl.formKey=='jurisdiction'?selectJurisdiction:apiUrl.formKey=='basisOfValuation'?selectBasisOfValuation:
        apiUrl.formKey=='riskCovered'?selectRiskCovered: apiUrl.formKey=='conveyance'?selectConveyance: apiUrl.formKey=='projectPeriodRf'?
        selectProjectPeriod:apiUrl.formKey=='modeOfTransit'?selectModeOfTransit:apiUrl.formKey=='packingRf'?selectPackingRf:null);

  useEffect(() => {
    checkPermission(apiUrl.permission_key, 'Create').then((permission) => {
      setRiskFactorCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange(apiUrl.formKey, index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    setOpenCreateModal(false);
    fetchRiskfactorMaster(productId, apiUrl.get_url, apiUrl.riskFactor).then((data) => {
      dispatch(setDataSuccess({ dataType: apiUrl.formKey, data }));
    });
  };

  const error = false; // Plug in validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id={`select-label-${apiUrl.formKey}`} error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId={`select-label-${apiUrl.formKey}`}
          id={`select-${apiUrl.formKey}`}
          value={tableListDatas[index]?.[apiUrl.formKey] || ''}
          onChange={(event) => {
            handleChange(apiUrl.formKey, index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {riskFactorData?.map((riskFactor) => (
            <MenuItem key={riskFactor.name} value={riskFactor.name}>
              {riskFactor.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              riskFactorCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Risk Factor
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (riskFactorCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: riskFactorCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && <FormHelperText error={true}>Validation error</FormHelperText>}
      </FormControl>

      {openCreateModal && (
        <RiskFactorCreateModal
          handleClose={handleClose}
          riskFactorname={riskFactorname}
          apiUrl={apiUrl}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default CommonRiskFactorList;
